$('.sticky-sidebar').each((i, el) => {
		const $el = $(el);
		const $main = $el.find('.sticky-sidebar__main');
		const $sidebar = $el.find('.sticky-sidebar__sidebar');
		const $headings = $main.find('h2, h3, h4, h5, h6');

		$headings.each((i, heading) => {
			const $this = $(heading);
			const id = $this.text().replace(/\s/g, "-").toLowerCase();

			$this.prepend(`<a class="anchor" id="${id}"></a>`);

			$sidebar.find('ul').append(`
				<li class="wp-block-button is-style-link-text-black">
					<a href="#${id}" class="wp-block-button__link">${$this.text().trim()}</a>
				</li>
			`);
		});
});
